import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { MessageCircle, Layers, Users, Database, Headphones } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const icons = [MessageCircle, Layers, Users, Database, Headphones];

const PricingAddons = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t, tObject } = useLanguage();
  const addons = tObject<Array<{ title: string; description: string; price: string; unit: string }>>("pricing.addons.items");
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className={cn("py-16 bg-secondary/30 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-8 text-center">{t("pricing.addons.title")}</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {addons.map((addon, index) => { const Icon = icons[index]; return (
              <div key={index} className={cn("bg-background rounded-xl border border-border p-5 transition-all duration-500 hover:shadow-md hover:border-chathero-mint/30", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")} style={{ transitionDelay: isVisible ? `${index * 75}ms` : "0ms" }}>
                <div className="w-10 h-10 rounded-lg bg-chathero-orange/10 flex items-center justify-center mb-3"><Icon className="w-5 h-5 text-chathero-orange" /></div>
                <h3 className="font-semibold text-foreground mb-1">{addon.title}</h3>
                <p className="text-sm text-muted-foreground mb-3">{addon.description}</p>
                <div className="flex items-baseline gap-1"><span className="text-xl font-bold text-primary">{addon.price}</span><span className="text-xs text-muted-foreground">{addon.unit}</span></div>
              </div>
            ); })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default PricingAddons;
